import { getProductById, getCollectProduct } from 'model/product';
import { getFilter } from 'model/filter';

export default store => ({
	path: 'product',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./home').default;
					cb(null, component);
				},
				'Products',
			),
		onEnter: () => {
			const {
				auth: { accessToken },
			} = store.getState();

			if (accessToken !== '') {
				store.dispatch(getCollectProduct());
			}

			store.dispatch(getFilter());
		},
	},
	childRoutes: [
		{
			path: ':id',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./component').default;
							cb(null, component);
						},
						'Product',
					),
				onEnter: ({ params: { id } }) => {
					store.dispatch(getProductById(id));

					const {
						auth: { accessToken },
					} = store.getState();

					if (accessToken !== '') {
						store.dispatch(getCollectProduct());
					}
				},
			},
		},
	],
});
